module.exports = __webpack_public_path__ + "img/goods10_2.1051fd4a.jpg";